import React from 'react'
import Card from './Card';
import CoinItem from '../data/CoinItem';
import './Pricings.css'

const Pricing = () => {

    const CardElements = CoinItem.map((item, index) => {
        return <Card key={index} items={item} />
    })


    return (
        <div className='pricing'>
            <div className='card-container'>
                {CardElements}
            </div>
        </div>
    );
}

export default Pricing